
import React from "react";
import { Category } from "@/types";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Pencil, Trash2 } from "lucide-react";

interface CategoriesTableProps {
  categories: Category[];
  subcategories: Category[];
  activeTab: "categories" | "subcategories";
  onEdit: (item: Category) => void;
  onDelete: (id: string) => void;
}

const CategoriesTable: React.FC<CategoriesTableProps> = ({
  categories,
  subcategories,
  activeTab,
  onEdit,
  onDelete
}) => {
  const displayItems = activeTab === "categories" ? categories : subcategories;

  return (
    <div className="rounded-md border border-gray-700 overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-brand-dark hover:bg-brand-dark/80">
            <TableHead className="text-white">Imagem</TableHead>
            <TableHead className="text-white">Nome</TableHead>
            <TableHead className="text-white">
              {activeTab === "categories" ? "Subcategorias" : "Categoria Principal"}
            </TableHead>
            <TableHead className="text-white w-[100px]">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {displayItems.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="text-center py-6 text-gray-400">
                {`Nenhuma ${activeTab === "categories" ? "categoria" : "subcategoria"} registada`}
              </TableCell>
            </TableRow>
          ) : (
            displayItems.map(item => {
              let additionalInfo;
              
              if (activeTab === "categories") {
                const subcategoryCount = subcategories.filter(
                  sub => sub.parentId === item.id
                ).length;
                
                additionalInfo = (
                  <span className="px-2 py-1 rounded-full text-xs bg-gray-700 text-gray-300">
                    {subcategoryCount} subcategorias
                  </span>
                );
              } else {
                const parentCategory = categories.find(
                  cat => cat.id === item.parentId
                );
                
                additionalInfo = parentCategory ? parentCategory.name : "Categoria não encontrada";
              }
              
              return (
                <TableRow key={item.id} className="hover:bg-brand-dark/50">
                  <TableCell>
                    <img
                      src={item.image || "/lovable-uploads/60244da3-6deb-4628-b29a-c8e90866808e.png"}
                      alt={item.name}
                      className="w-10 h-10 rounded object-cover"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = "/lovable-uploads/60244da3-6deb-4628-b29a-c8e90866808e.png";
                      }}
                    />
                  </TableCell>
                  <TableCell className="font-medium">{item.name}</TableCell>
                  <TableCell>{additionalInfo}</TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <Button
                        size="icon"
                        variant="ghost"
                        onClick={() => onEdit(item)}
                        className="h-8 w-8 text-gray-400 hover:text-white hover:bg-gray-800"
                      >
                        <Pencil size={16} />
                      </Button>
                      <Button
                        size="icon"
                        variant="ghost"
                        onClick={() => onDelete(item.id)}
                        className="h-8 w-8 text-gray-400 hover:text-white hover:bg-gray-800"
                      >
                        <Trash2 size={16} />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default CategoriesTable;
